import React from "react";
import styles from "./DpEmergencyPatientInfo.module.scss";
import {AmbulanceNewIcon, FemaleIcon} from "../../../assets";
import {InfoText} from "../../../shared";
import moment from "moment/moment";

const DpEmergencyPatientInfo = ({br}) => {
  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <FemaleIcon className='mr-5'/>
        <div className={styles.title} >Данные о пациенте</div>
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcText} title={'Пациент'} text={br?.patient_name || br?.name}/>
        <InfoText className={styles.dcText} title={'Дата Рождения'} text={`${moment(br?.birthday).format('DD/MM/YYYY')}`}/>
        <InfoText className={styles.dcText} title={'Город'} text={br?.city}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcTextComplaints} title={'Адрес'} text={br?.address}/>
        <InfoText className={styles.dcTextComplaints} title={'Телефон'} text={`+7${br?.contact_number}`}/>
      </div>
      <div className={styles.wrapper}>
        <InfoText className={styles.dcTextComplaints} title={'Жалобы'} text={br?.complaints}/>
      </div>
      {br?.notes &&  <div className={styles.wrapper}>
         <InfoText className={styles.dcText} title={'Дополнительная информация'} text={br?.notes}/>
        {/*<InfoText className={styles.dcText} title={'Запрос госпитализации'} text={br?.data?.need_hospitalization ? "Да" : "Нет"}/>*/}
      </div>}
      {br?.data?.need_hospitalization &&
        <div className={styles.wrapper}>
          <InfoText className={styles.dcText} title={'Название стационара'} text={br?.data?.station_info }/>
          <InfoText className={styles.dcText} title={'Адрес стационара'} text={br?.data?.station_info_address}/>
        </div>
      }
    </div>
  </div>
}

export default DpEmergencyPatientInfo
